export function formatNumber(number, decimals, dec_point, thousands_sep){
    var n = !isFinite(+number) ? 0 : +number, 
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        toFixedFix = function (n, prec) {
            // Fix for IE parseFloat(0.55).toFixed(0) = 0;
            var k = Math.pow(10, prec);
            return Math.round(n * k) / k;
        },
        s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

export function formattedNumberToInt(number, dec_point, thousands_sep){
    let number_decimal = number.split(dec_point)[0];
    let thousand_groups = number_decimal.split(thousands_sep);
    let result = '';
    for(let i = 0; i < thousand_groups.length; i++){
        result += thousand_groups[i];
    }
    return parseInt(result);
}

export function manageCommissionsTable()
{
    let table = null;
    if($('#commissions-table').length > 0){
        table = $('#commissions-table').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            ajax: {
                url: '/datatables/commissions',
                type: 'GET',
                data: function(d){
                    d.donor_id = $('input[name="donor_id"]').val();
                    d.donor_name = $('input[name="donor_name"]').val();  // Aggiungi il filtro per il donatore
                    d.user_name = $('input[name="user_name"]').val();    // Aggiungi il filtro per l'operatore
                    d.budget = $('input[name="budget"]').val();     
                }
            },
            columns: [
                {name: 'action', data: 'action'},
                {name: 'donor_name', data: 'donor_name', width: '50%', orderable: true},
                {name: 'budget', data: 'budget', width: '50%', orderable: true},
            ],
            language: {
                "sLengthMenu": "_MENU_ Incarichi per pagina",
                "sZeroRecords": "Nessun incarico",
                "sInfo": "Mostra da _START_ a _END_ di _TOTAL_ Incarichi",
                "sInfoEmpty": "0 di 0 su 0 Incarichi",
                "sInfoFiltered": "(Filtrati _MAX_ Incarichi)",
                "sInfoPostFix": "",
                "sSearch": "Cerca",
                "oPaginate": {
                    "sFirst":    "Inizio",
                    "sPrevious": "Indietro",
                    "sNext":     "Avanti",
                    "sLast":     "Fine"
                }
            },
            searching: false,
            order: [[2, "asc"]],
            lengthMenu: [10, 25, 50]
          });
        
    } else if($('#commissions-table-admin').length > 0){
        table = $('#commissions-table-admin').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            ajax: {
                url: '/datatables/commissions',
                type: 'GET',
                data: function(d){
                    
                    d.donor_id = $('input[name="donor_id"]').val();  // Aggiungi nome del donatore
                    d.user_id = $('input[name="user_id"]').val();    // Aggiungi nome operatore
                    d.budget = $('input[name="budget"]').val();      // Aggiungi budget
                    d.donor_name = $('input[name="donor_name"]').val();  // Aggiungi il filtro per il donatore
                    d.user_name = $('input[name="user_name"]').val();    
                }
            },
            columns: [
                {name: 'action', data: 'action', width: '25%'},
                {name: 'donor_name', data: 'donor_name', width: '25%', orderable: true},  // Colonna per il nome del donatore
                {name: 'users.name', data: 'user_name', width: '25%', orderable: true},  // Colonna per il nome dell'operatore
                {name: 'budget', data: 'budget', width: '25%', orderable: true},
            ],
            language: {
                "sLengthMenu": "_MENU_ Incarichi per pagina",
                "sZeroRecords": "Nessun incarico",
                "sInfo": "Mostra da _START_ a _END_ di _TOTAL_ Incarichi",
                "sInfoEmpty": "0 di 0 su 0 Incarichi",
                "sInfoFiltered": "(Filtrati _MAX_ Incarichi)",
                "sInfoPostFix": "",
                "sSearch": "Cerca",
                "oPaginate": {
                    "sFirst":    "Inizio",
                    "sPrevious": "Indietro",
                    "sNext":     "Avanti",
                    "sLast":     "Fine"
                }
            },
            searching: false,
            order: [[1, "desc"]],
            lengthMenu: [10, 25, 50]
        });
       
      $('#start_search').on('click', function(e) {
    e.preventDefault();
    var filters = {
        donor_name: $('input[name="donor_name"]').val(),
        user_name: $('input[name="user_name"]').val(),
        budget: $('input[name="budget"]').val(),
      
    };

    table.ajax.url('/datatables/commissions/').load();  // Modifica l'URL della richiesta AJAX
});
    }
    

    return table;
   
}